var exports = {
  "kL": "FriendSelector.module__container___UzBoT0",
  "hJ": "FriendSelector.module__searchField___UzBoT0",
  "lA": "FriendSelector.module__searchFieldInner___UzBoT0",
  "t$": "FriendSelector.module__selectedPill___UzBoT0",
  "DT": "FriendSelector.module__removeButton___UzBoT0",
  "qc": "FriendSelector.module__searchIcon___UzBoT0",
  "D3": "FriendSelector.module__searchIconFocused___UzBoT0",
  "Rt": "FriendSelector.module__searchInput___UzBoT0",
  "XG": "FriendSelector.module__scroller___UzBoT0",
  "yY": "FriendSelector.module__scrollerNoSearch___UzBoT0",
  "p$": "FriendSelector.module__emptyState___UzBoT0",
  "q6": "FriendSelector.module__emptyStateText___UzBoT0",
  "_s": "FriendSelector.module__groupsContainer___UzBoT0",
  "cp": "FriendSelector.module__groupLetter___UzBoT0",
  "QS": "FriendSelector.module__friendsList___UzBoT0",
  "jZ": "FriendSelector.module__friendButton___UzBoT0",
  "An": "FriendSelector.module__friendButtonSelected___UzBoT0",
  "FI": "FriendSelector.module__friendButtonDisabled___UzBoT0",
  "Hb": "FriendSelector.module__friendInfo___UzBoT0",
  "G3": "FriendSelector.module__friendName___UzBoT0",
  "HI": "FriendSelector.module__checkboxContainer___UzBoT0",
  "Yz": "FriendSelector.module__removeIcon___UzBoT0",
};

module.exports = exports;
